import * as React from "react";

import "./row-expansion.scss";

import {upperCase1} from "@Common/utils/strings";

import {ApprovalRequestAttributesDict, ApprovalRequestOrderAttributesDict}  from "../../approval-request-attributes";
import {ApprovalRequest}                                                    from "../../approval-requests";
import {mapAppliedPaymentsAsList}                                           from "../../common/payments";
import {AmountBreakdown}                                                    from "./amount-breakdown/amount-breakdown";
import {Card}                                                               from "./card/card";
import {Payment}                                                            from "./payment/payment";
import {ReceiptDetails}                                                     from "./receipt-details/receipt-details";

export const RowExpansion = ({
    approval: {appliedCredits, appliedPayments, orders},
    attributes,
    ordersAttributes,
}:{
    approval            : ApprovalRequest,
    attributes          : ApprovalRequestAttributesDict,
    ordersAttributes    : ApprovalRequestOrderAttributesDict[],
}) => (
        <div className="expansion-44k">
            <div className="cards">
                {(orders as typeof orders[number][]).map((order, index) => (
                    <React.Fragment key={order.idOrder}>
                        {Card({order, attributes: ordersAttributes[index]})}
                    </React.Fragment>
                ))}
            </div>

            {(attributes.deny || attributes.goToCart || attributes.price) && (
                <div className="bottom">
                    {(attributes.deny || attributes.goToCart) && (
                        <div className="receipt-details">
                            {ReceiptDetails({onDenyCart: attributes.deny?.run, onViewCart: attributes.goToCart?.run})}
                        </div>
                    )}

                    {attributes.price && (
                        <div className="amounts">
                            {AmountBreakdown({amounts: Object.keys(attributes.price.breakdown).map(priceType => ({
                                label: priceType.split(/(?=[A-Z])/).map(upperCase1).join(" "),
                                value: attributes.price.breakdown[priceType],
                            })), rdfDescription: attributes?.rdfDescription?.value
                            })}

                            {Payment({
                                payments    : mapAppliedPaymentsAsList({appliedCredits, appliedPayments}),
                                onApprove   : attributes.approve?.run,
                            })}
                        </div>
                    )}
                </div>
            )}
        </div>
);

